import type { FC, ReactNode } from 'react';
import { isString } from 'lodash-es';

export interface ToastContentProps {
  title: string;
  description: string | ReactNode;
}

export const ToastContent: FC<ToastContentProps> = ({ description, title }) => {
  return (
    <div className="flex flex-col gap-1">
      <p className="text-info-900 mt-[3px] leading-5 font-medium">{title}</p>
      {isString(description) ? (
        <p className="text-info-500 text-sm leading-5 font-normal">{description}</p>
      ) : (
        description
      )}
    </div>
  );
};
